import { useMemo } from 'react';
import { CreateEntityButtonConfig } from 'record-it-components/pageContentLayout/ManageEntitiesContentLayout/ManageEntitiesContentLayout';
import { UserGroup } from '../../classes/entities/UserGroup/userGroupTypes';
import { UserGroupUtils } from '../../classes/entities/UserGroup/UserGroupUtils';

export function useUserGroupCreateEntityButtonConfig({
  text,
  userGroups,
  onCreateEntity
}: {
  text: string;
  userGroups: Array<UserGroup>;
  onCreateEntity: (userGroup: UserGroup | null) => void;
}): CreateEntityButtonConfig<UserGroup> {
  return useMemo<CreateEntityButtonConfig<UserGroup>>(() => {
    return {
      visible: true,
      dropdownItems: userGroups,
      getDropdownItemDisplayText: UserGroupUtils.displayTextGetter,
      getDropdownItemKey: UserGroupUtils.keyGetter,
      onCreateEntity,
      text
    };
  }, [userGroups, text, onCreateEntity]);
}
